import Vue from 'vue'
import Router from 'vue-router'
import ruiDate from "@/utils/ruiDate";

Vue.use(Router);

const createRouter = () => new Router({
   // mode: 'history',
   routes: [{
      path: '/',
      component: () => import('@/views/login'),
   }, {
      path: '/forget',
      component: () => import('@/views/login/forget.vue')
   }, {
      path: '/register',
      component: () => import('@/views/register'),
   }, {
      //登录后框架页面
      path: '/index',
      component: () => import('@/views/index/index.vue'),
      meta: {
         requireAuth: true
      },
      children: [{
         path: '/changepassword',
         component: () => import('@/views/changepassword/index.vue'),
         meta: {
            requireAuth: true
         }
      }, {
         /*科技成果                                                               申请单位*/
         path: 'techAchieveApply',
         component: () => import('@/views/techAchieveApply/index.vue'),
         children: [{
            //项目类型列表
            path: 'projectList',
            name: 'techAchieveApply_projectList',
            component: () => import('@/views/techAchieveApply/projectList.vue'),
            meta: {
               activeMenu: '/index/techAchieveApply/projectList',
               requireAuth: true,
               loginRole: 'apply'
            }
         }, {
            //申报界面
            path: 'apply',
            name: 'techAchieveApply_apply',
            component: () => import('@/views/techAchieveApply/apply.vue'),
            meta: {
               activeMenu: '/index/techAchieveApply/applyList',
               requireAuth: true,
               loginRole: 'apply'
            }
         }, {
            //申报明细列表
            path: 'applyList',
            name: 'techAchieveApply_applyList',
            component: () => import('@/views/techAchieveApply/applyList.vue'),
            meta: {
               activeMenu: '/index/techAchieveApply/applyList',
               requireAuth: true,
               loginRole: 'apply'
            }
         }]
      }]
   }]
})

const router = createRouter();

router.beforeEach((to, from, next) => {
   console.log('to', to)
   console.log('from', from)
   console.log('expire', localStorage.getItem('expire'));

   if (to.matched.length != 0) {
      //判断该路由是否需要登录权限
      if (to.meta.requireAuth) {

         //拦截申报单位访问推荐单位的页面
         if (localStorage.getItem('loginRoleId') == 0 && to.meta.loginRole == 'recom') {
            next('/')
            return;
         }
         //拦截推荐单位访问申报单位的页面
         if (localStorage.getItem('loginRoleId') == 1 && to.meta.loginRole == 'apply') {
            next('/')
            return;
         }

         //如果过期，则回登录，否则更新过期时间
         const expireMinute = ruiDate.getDiffMinute(ruiDate.getNowTime(), localStorage.getItem('expire'));
         console.info(`已过期${expireMinute}分钟`);
         if (expireMinute > 20) {
            next('/')
            return;
         } else {
            localStorage.setItem("expire", ruiDate.getNowTime())
         }

         //通过浏览器本地缓存判断当前的token是否存在
         if (Boolean(localStorage.getItem('token'))) {
            next()
            return;
         } else {
            next('/')
            return;
         }
      } else {
         next()
         return;
      }
   } else {
      console.info('未匹配回登录页面', to.fullPath);
      next('/')
      return;
   }
})

const originalPush = Router.prototype.replace
Router.prototype.replace = function replace(location, onResolve, onReject) {
   if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
   return originalPush.call(this, location).catch(err => err)
}

export function resetRouter() {
   const newRouter = createRouter()
   router.matcher = newRouter.matcher // the relevant part
}

export default router;
